/**
 * Constantes exclusivas de musculação que pertencem à camada de UI/editor.
 * As constantes de domínio (MUSCLE_GROUPS, STRENGTH_EQUIPMENT, etc.)
 * vivem em domain/strength/constants.js.
 */

export const STRENGTH_SPLIT_OPTIONS = [
    { value: "full_body", label: "Full Body" },
    { value: "upper_lower", label: "Upper / Lower" },
    { value: "push_pull_legs", label: "Push / Pull / Legs" },
    { value: "abc", label: "ABC" },
    { value: "abcd", label: "ABCD" },
    { value: "custom", label: "Personalizada" },
];

export const TRAINING_METHODS = [
    { value: "normal",       label: "Normal",          desc: "Exercícios independentes com descanso entre séries", color: "#6c757d" },
    { value: "biset",        label: "Bi-set",          desc: "2 exercícios executados em sequência sem descanso", color: "#3b5de7" },
    { value: "triset",       label: "Tri-set",         desc: "3 exercícios em sequência sem descanso", color: "#7c3aed" },
    { value: "giantset",     label: "Giant Set",       desc: "4+ exercícios em sequência sem descanso", color: "#dc3545" },
    { value: "superset",     label: "Super-série",     desc: "2 exercícios antagonistas sem descanso (ex: bíceps + tríceps)", color: "#8b5cf6" },
    { value: "circuit",      label: "Circuito",        desc: "Todos os exercícios em sequência com descanso mínimo", color: "#0ea5e9" },
];
